/* Productreviews, compact (r7, Geert 31-10-2026: "Kunnen we het review blok compacter maken zodat er meer tegelijk leesbaar
   zijn en de toon meer reviews een naar rechts klik kan zijn"; opbouw in snippets/banky-product-reviews-blok.liquid).
   Laadt pas als het blok in de buurt komt (inline lader in die snippet).
   - Schuifrij: alle kaarten die bij het filter passen staan in één rij (scroll snap); de pijlknoppen schuiven een schermvol
     kaarten (3 op web, 2 op tablet, 1 op mobiel) en zijn aria-disabled aan het begin en het eind (ze houden de focus).
     Na een klik op een pijl meldt de statusregel "Review 4 van 19" (banky_carousel.position).
   - Filterchips per aantal sterren (met telling), zoals WP2.3: kiezen zet de rij terug naar het begin en meldt de keuze.
   - "Lees verder" per kaart (uitklap in de kaart, aria-expanded en aria-controls): alleen op kaarten waarvan de tekst of de
     titel is afgekapt of die pluspunten hebben. De knop staat op de regel van "Bron: ...", dus hij verschuift niets.
   - data-aantal op het blok: het aantal kaarten in de rij (de CSS maakt de kaarten breder en verbergt de pijlen bij weinig
     reviews).
   - Herberekening na het live laden van Judge.me: banky-sales.js vervangt de Judge.me-kaarten en werkt het gemiddelde bij;
     dit script telt de chips opnieuw, zet de sterren op het nieuwe gemiddelde en toont alle passende kaarten. banky-sales.js
     pagineert dezelfde kaarten nog (hidden); dit script houdt het laatste woord over welke kaart zichtbaar is.
   Alle kaarten en alle tekst staan in de HTML. Teksten via data-tekst-* op het blok (bestaande sleutels). */
(() => {
  const sterrenVan = kaart => Number((kaart.querySelector('.banky-review__stars')?.getAttribute('aria-label') || '').split(' ')[0]) || 0;
  const vul = (sjabloon, waarden) => String(sjabloon || '').replace(/#(\w+)#|\{(\w+)\}/g, (m, a, b) => { const k = a || b; return k in waarden ? waarden[k] : m; });
  const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  let volgnummer = 0;

  function start(root) {
    if (root.dataset.bankyReviewsKlaar) return;
    const lijst = root.querySelector('[data-banky-product-reviews]');
    const grid = lijst && lijst.querySelector('.banky-review-grid');
    if (!grid) return;
    root.dataset.bankyReviewsKlaar = '1';
    root.classList.add('is-actief');

    const groep = root.querySelector('.banky-pr__filters');
    const status = root.querySelector('[data-banky-reviews-status]');
    const sterren = root.querySelector('.banky-pr__sterren');
    const vorige = root.querySelector('[data-banky-reviews-vorige]');
    const volgende = root.querySelector('[data-banky-reviews-volgende]');
    const tekst = root.dataset;
    let filter = 'alle';
    let gewenst = new Map();
    let gepland = 0, navGepland = 0, eindTimer = 0, meldPositie = false, breedte = 0;

    const kaarten = () => [...grid.querySelectorAll('.banky-review')];
    const zichtbaar = () => kaarten().filter(k => !k.hidden);
    const chips = () => (groep ? [...groep.querySelectorAll('[data-banky-reviews-filter]')] : []);
    const passend = () => kaarten().filter(k => filter === 'alle' || String(sterrenVan(k)) === filter);
    const meld = t => { if (status) status.textContent = t; };

    // Chips en sterren bijwerken op de kaarten die er nu staan (ook na het live laden van Judge.me).
    function tel() {
      const alle = kaarten();
      const per = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0};
      alle.forEach(k => { const s = sterrenVan(k); if (s in per) per[s]++; });
      if (groep) {
        const voorbeeld = groep.querySelector('[data-banky-reviews-filter]:not([data-banky-reviews-filter="alle"])');
        for (const s of [5, 4, 3, 2, 1]) {
          if (!per[s] || groep.querySelector(`[data-banky-reviews-filter="${s}"]`) || !voorbeeld) continue;
          // Een aantal sterren dat pas met de live reviews verschijnt: chip op de juiste plek erbij.
          const nieuw = voorbeeld.cloneNode(true);
          nieuw.dataset.bankyReviewsFilter = String(s);
          nieuw.setAttribute('aria-pressed', 'false');
          nieuw.firstChild.textContent = String(s);
          const na = [...groep.querySelectorAll('[data-banky-reviews-filter]')].find(c => c.dataset.bankyReviewsFilter !== 'alle' && Number(c.dataset.bankyReviewsFilter) < s);
          groep.insertBefore(nieuw, na || null);
        }
        let niveaus = 0;
        chips().forEach(c => {
          const f = c.dataset.bankyReviewsFilter;
          const n = f === 'alle' ? alle.length : per[f] || 0;
          const t = c.querySelector('.banky-pr__telling');
          if (t && t.textContent !== String(n)) t.textContent = String(n);
          c.setAttribute('aria-label', f === 'alle' ? vul(tekst.tekstAlle, {aantal: n}) : vul(tekst.tekstSter, {sterren: f, aantal: n}));
          if (f !== 'alle') { c.hidden = n === 0; if (n) niveaus++; }
        });
        groep.hidden = niveaus < 2;
        if (filter !== 'alle' && (groep.hidden || !per[filter])) kies('alle', false);
      }
      const gemiddelde = Number((lijst.querySelector('.banky-product-reviews__head p strong')?.textContent || '').replace(',', '.'));
      if (sterren && gemiddelde > 0) sterren.style.setProperty('--banky-pr-score', Math.round(gemiddelde * 20) + '%');
    }

    // Alle passende kaarten in de rij, de rest hidden.
    function toon() {
      const alle = kaarten();
      const aan = new Set(passend());
      gewenst = new Map(alle.map(k => [k, !aan.has(k)]));
      alle.forEach(k => { if (k.hidden !== gewenst.get(k)) k.hidden = gewenst.get(k); });
      if (root.dataset.aantal !== String(aan.size)) root.dataset.aantal = String(aan.size);
      knoppen();
      nav();
    }

    // "Lees verder" per kaart: eerst alle knoppen plaatsen (schrijven), dan meten (lezen), dan tonen of verbergen (schrijven).
    function knoppen() {
      const lijstNu = zichtbaar();
      for (const k of lijstNu) {
        if (k.querySelector(':scope > .banky-review__meer')) continue;
        const t = k.querySelector('.banky-review__text');
        const knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'banky-review__meer';
        knop.hidden = true;
        knop.setAttribute('aria-expanded', k.classList.contains('is-open') ? 'true' : 'false');
        if (t) { if (!t.id) t.id = 'banky-review-tekst-' + (++volgnummer); knop.setAttribute('aria-controls', t.id); }
        knop.textContent = k.classList.contains('is-open') ? tekst.tekstMinder : tekst.tekstMeer;
        k.insertBefore(knop, k.querySelector(':scope > .banky-review__origin'));
      }
      const nodig = lijstNu.map(k => {
        if (k.classList.contains('is-open')) return true;
        const t = k.querySelector('.banky-review__text');
        const titel = k.querySelector(':scope > h3');
        return !!k.querySelector('.banky-review__points') || (t && t.scrollHeight > t.clientHeight + 1) || (titel && titel.scrollWidth > titel.clientWidth + 1);
      });
      lijstNu.forEach((k, i) => { const knop = k.querySelector(':scope > .banky-review__meer'); if (knop && knop.hidden !== !nodig[i]) knop.hidden = !nodig[i]; });
    }

    function klap(knop) {
      const kaart = knop.closest('.banky-review');
      if (!kaart) return;
      const open = !kaart.classList.contains('is-open');
      kaart.classList.toggle('is-open', open);
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      knop.textContent = open ? tekst.tekstMinder : tekst.tekstMeer;
      // Dicht en de kaart begint boven het scherm: terug naar de kaart, zodat je niet ergens halverwege de pagina staat.
      if (!open && kaart.getBoundingClientRect().top < 0) kaart.scrollIntoView({block: 'nearest'});
      nav();
    }

    // Pijlen: aria-disabled aan het begin en het eind (geen disabled, dan houdt de knop de focus).
    function nav() {
      if (!vorige || !volgende) return;
      const max = grid.scrollWidth - grid.clientWidth;
      const begin = grid.scrollLeft <= 1, eind = grid.scrollLeft >= max - 1;
      if (vorige.getAttribute('aria-disabled') !== String(begin)) vorige.setAttribute('aria-disabled', String(begin));
      if (volgende.getAttribute('aria-disabled') !== String(eind)) volgende.setAttribute('aria-disabled', String(eind));
    }
    // Een schermvol kaarten: zoveel als er helemaal in de rij passen (minstens één).
    function stap() {
      const lijstNu = zichtbaar();
      if (!lijstNu.length) return grid.clientWidth;
      const s = getComputedStyle(grid);
      const gat = parseFloat(s.columnGap) || 0;
      const binnen = grid.clientWidth - (parseFloat(s.paddingLeft) || 0) - (parseFloat(s.paddingRight) || 0);
      const b = lijstNu[0].getBoundingClientRect().width;
      const n = Math.max(1, Math.floor((binnen + gat + 1) / (b + gat)));
      return n * (b + gat);
    }
    function schuif(richting) {
      meldPositie = true;
      grid.scrollBy({left: richting * stap(), behavior: rustig.matches ? 'auto' : 'smooth'});
    }
    function positie() {
      nav();
      if (!meldPositie) return;
      meldPositie = false;
      const lijstNu = zichtbaar();
      const links = grid.getBoundingClientRect().left + (parseFloat(getComputedStyle(grid).paddingLeft) || 0);
      // De eerste kaart die op of na de linkerrand van de rij begint (bij scroll snap de kaart op de snappositie). Aan het
      // eind van de rij is de laatste stap korter en steekt de vorige kaart nog half in de marge; die telt niet, anders
      // meldt de laatste klik op de telefoon "Review 27 van 28" terwijl kaart 28 in beeld staat (eindcontrole r7, 31-10).
      let i = lijstNu.findIndex(k => k.getBoundingClientRect().left >= links - 2);
      if (i < 0) i = lijstNu.findIndex(k => k.getBoundingClientRect().right > links + 2);
      if (i >= 0 && tekst.tekstPositie) meld(vul(tekst.tekstPositie, {current: i + 1, total: lijstNu.length}));
    }

    function kies(f, melden) {
      filter = f;
      chips().forEach(c => c.setAttribute('aria-pressed', c.dataset.bankyReviewsFilter === f ? 'true' : 'false'));
      toon();
      grid.scrollLeft = 0;
      nav();
      if (melden) { const c = chips().find(x => x.dataset.bankyReviewsFilter === f); if (c) meld(c.getAttribute('aria-label')); }
    }

    if (groep) groep.addEventListener('click', e => {
      const c = e.target.closest('[data-banky-reviews-filter]');
      if (!c || c.getAttribute('aria-pressed') === 'true') return;
      kies(c.dataset.bankyReviewsFilter, true);
    });

    root.addEventListener('click', e => {
      const knop = e.target.closest('.banky-review__meer');
      if (knop && root.contains(knop)) { klap(knop); return; }
      const pijl = e.target.closest('[data-banky-reviews-vorige],[data-banky-reviews-volgende]');
      if (!pijl || pijl.getAttribute('aria-disabled') === 'true') return;
      schuif(pijl.hasAttribute('data-banky-reviews-volgende') ? 1 : -1);
    });

    grid.addEventListener('scroll', () => {
      if (!navGepland) navGepland = requestAnimationFrame(() => { navGepland = 0; nav(); });
      clearTimeout(eindTimer);
      eindTimer = setTimeout(positie, 160);
    }, {passive: true});

    // Andere breedte: andere inkorting, dus opnieuw bepalen welke kaart "Lees verder" nodig heeft.
    if ('ResizeObserver' in window) new ResizeObserver(() => {
      const b = Math.round(grid.clientWidth);
      if (b === breedte) return;
      breedte = b;
      knoppen();
      nav();
    }).observe(grid);

    // banky-sales.js vervangt kaarten (live Judge.me) of zet hidden via zijn eigen paginering: bijwerken en het laatste woord houden.
    new MutationObserver(records => {
      if (records.some(r => r.type === 'childList' && r.target === grid)) { tel(); toon(); return; }
      if (gepland) return;
      gepland = requestAnimationFrame(() => {
        gepland = 0;
        if (kaarten().some(k => gewenst.has(k) && k.hidden !== gewenst.get(k))) toon();
      });
    }).observe(grid, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});

    tel();
    toon();
    // Met de echte letter (Poppins laadt soms later) kan een tekst net wel of net niet passen.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => knoppen());
  }

  const alles = () => document.querySelectorAll('[data-banky-reviews]').forEach(start);
  window.bankyReviews = alles;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  document.addEventListener('shopify:section:load', alles);
})();
